import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { applyBufferData } from '../../actions/buffer';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$deliveryTime',
  initialState,
  reducers: {
    setDeliveryTime(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(resetOrder, (_state, _action) => {
        return initialState;
      })
      .addCase(applyBufferData, (state, action) => {
        const { deliveryTime } = action.payload;
        return deliveryTime === undefined ? state : deliveryTime;
      });
  },
});

export const { setDeliveryTime } = slice.actions;
export default slice.reducer;
